import { Channel } from "@/models/channel";

export class Group {
	public static parse(data: IGroup): Group {
		const group: Group = new Group();
		if (data.id !== undefined) {
			group.id = data.id;
		}
		if (data.displayName !== undefined) {
			group.displayName = data.displayName;
		}
		if (data.description !== undefined) {
			group.description = data.description;
		}
		if (data.isArchived !== undefined) {
			group.isArchived = data.isArchived;
		}
		if (data.channels !== undefined) {
			group.channels = data.channels;
		}
		return group;
	}
	public id: string = "";
	public displayName: string = "";
	public description: string = "";
	public isArchived: boolean = false;
	public channels: Channel[] = [];
}

export interface IGroup {
	id?: string;
	displayName?: string;
	description?: string;
	isArchived?: boolean;
	channels?: Channel[];
}
